import React from "react";
import styles from "../styles/rightsListGen.module.css";
import RightsListHeader from "./RightsListHeader";
import RightsTile from "../store/containers/RightsTileContainer";
import TileType from "../constants/TileType";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTrail } from "react-spring";

const RightsListGen = ({
  categoryTitle,
  categoryCount,
  rightsListData,
  rightsListDataType,
  selectedRightCategory,
  selectedSubright,
  isRightsLoading,
  isSubrightsLoading,
  isLearnMoresLoading,
}) => {
  const navigate = useNavigate();
  const trail = useTrail(rightsListData.length, {
    from: { marginTop: -40, opacity: 0 },
    to: { marginTop: 0, opacity: 1 },
    delay: 400,
  });

  const renderList = () => {
    return trail.map((props, index) => {
      return (
        <RightsTile
          rightData={rightsListData[index]}
          tileType={rightsListDataType}
          key={rightsListData[index].id}
          animateStyle={props}
        />
      );
    });
  };

  const addRightData = () => {
    if (rightsListDataType === TileType.RIGHT) {
      navigate("/rights/info", { state: { editMode: false } });
    } else if (rightsListDataType === TileType.SUBRIGHT) {
      if (selectedRightCategory != null) {
        navigate("/rights/subright", {
          state: { editMode: false },
        });
      }
    } else if (rightsListDataType === TileType.LEARNMORE) {
      if (selectedSubright != null) {
        navigate("/rights/learnMore", {
          state: { editMode: false },
        });
      }
    }
  };

  const isLoading = () => {
    return (
      (rightsListDataType === TileType.RIGHT && isRightsLoading) ||
      (rightsListDataType === TileType.SUBRIGHT && isSubrightsLoading) ||
      (rightsListDataType === TileType.LEARNMORE && isLearnMoresLoading)
    );
  };

  const loadingText = () => {
    switch (rightsListDataType) {
      case TileType.RIGHT:
        return "Loading Rights...";
      case TileType.SUBRIGHT:
        return "Loading Subrights...";
      case TileType.LEARNMORE:
        return "Loading Learn Mores...";
      default:
        return "";
    }
  };

  return (
    <div className={styles.container}>
      <RightsListHeader
        title={categoryTitle}
        categoryCount={categoryCount}
        addFunction={addRightData}
      />
      {isLoading() ? (
        <div className={styles.tileContainerLoad}>
          <CircularProgress style={{ color: "#FC8E56" }} />
          <p>{loadingText()}</p>
        </div>
      ) : (
        <div className={styles.tileContainer}>{renderList()}</div>
      )}
    </div>
  );
};

export default RightsListGen;
